import moment from 'moment';

import {
  changeFieldValueAndUpdate,
  getCarData,
  getIsMotorFromSelector,
  setQuestionVisibility,
} from 'app/services/businessFunctionHelpers';
import { FieldsEnum, FormsEnum } from 'app/shared/enums';
import { getShouldHideDrivingWheelLocation } from 'app/services/businessFunctions/helpers/setDrivingWheelLocationVisibility';

const onOwnerPurchaseYearChange = {
  onOwnerPurchaseYearChange() {
    const {
      firstRegistrationCountry,
      firstRegistrationDate,
      ownerPurchaseYear,
    } = getCarData();

    const firstRegistrationDateYear = moment(firstRegistrationDate).year();
    const carOwnerPurchaseYear = Number(ownerPurchaseYear);
    const isMotor = getIsMotorFromSelector();
    const showCarDrivingWheelLocationFor = ['eur', 'other'];
    const shouldHideDrivingWheelLocation = getShouldHideDrivingWheelLocation();

    const isCarDrivingWheelLocationVisible =
      !shouldHideDrivingWheelLocation &&
      showCarDrivingWheelLocationFor.includes(firstRegistrationCountry) &&
      firstRegistrationDateYear !== carOwnerPurchaseYear;

    if (firstRegistrationDateYear === carOwnerPurchaseYear) {
      changeFieldValueAndUpdate(FieldsEnum.CarFirstRegistrationCountry, 'pol');
    }

    setQuestionVisibility({
      key: FieldsEnum.CarFirstRegistrationCountry,
      visible: firstRegistrationDateYear !== carOwnerPurchaseYear,
      formName: FormsEnum.CalculationForm,
    });

    if (!isMotor) {
      setQuestionVisibility({
        key: FieldsEnum.CarDrivingWheelLocation,
        visible: isCarDrivingWheelLocationVisible,
        formName: FormsEnum.CalculationForm,
      });
    }
  },
};

export default onOwnerPurchaseYearChange;
